import React, { useContext } from "react";
import "./style.css";
import { CrossIcon, PinkStar } from "../../../GlobalIcons";
import { filterDataContext } from "../../../../App";

const BottomSheetChip = ({
  name,
  popular,
  removeKey,
  searchParams,
  setSearchParams,
  filterChips,
  detail,
  item,
  createFilterParams,
  setSortingTabFromChips,
  handleOpenEvent,
}) => {
  const { setTicketAvailabiltyInput, setMaxPriceInput, setMinPriceInput } =
    useContext(filterDataContext);

  const RemoveParam = (Key) => {
    if (Key === "date") {
      searchParams.delete("date_start");
      searchParams.delete("date_stop");
    } else if (Key === "price") {
      searchParams.delete("minPrice");
      setMinPriceInput("");
      searchParams.delete("maxPrice");
      setMaxPriceInput("");
    } else if (Key === "ticket_Availability") {
      searchParams.delete("ticket_Availability");
      setTicketAvailabiltyInput("");
    } else {
      searchParams.delete(Key);
    }
    setSearchParams(searchParams);
  };

  const handleCLick = (item) => {
    createFilterParams(item);
  };

  return (
    <div
      className="bottomSheet_chip"
      style={{ cursor: filterChips !== "filterChips" ? "pointer" : "" }}
      onClick={() => {
        createFilterParams && handleCLick(item);
        handleOpenEvent && handleOpenEvent(item.event_id);
      }}
    >
      <h3
        onClick={() => {
          setSortingTabFromChips && setSortingTabFromChips(removeKey);
        }}
      >
        <span>
          <PinkStar />
        </span>
        {name}
        {detail && <p>{detail}</p>}
      </h3>
      {filterChips === "filterChips" && (
        <div
          className="chipCross_icon"
          onClick={() => {
            RemoveParam(removeKey);
          }}
        >
          <CrossIcon />
        </div>
      )}
    </div>
  );
};

export default BottomSheetChip;
